import React from 'react'
import {
    StyledListItem,
    StyledTextListItem,
} from '../../typography/List/List.styled'
import { Block } from '@news-mono/web-common'
import { ArticleBlock } from '../../publication/ArticleBlockContent/ArticleBlock'
import { GetVideoQueue } from '../../content/Video/PlayerInterface'
import { Logger } from 'typescript-log'
import { PlayerEvent } from '@news-mono/web-common'
import { LinkClickedEvent } from '@news-mono/web-common'
import { CardEvents } from '@news-mono/web-common'
import { CollectionEvent } from '@news-mono/web-common'

export function ListItem({
    blocks,
    onEvent,
    adUnitPath,
    publicationPathname,
    getVideoQueue,
    showInlineVideoTitles,
    log,
}: {
    blocks: Block[]
    onEvent: (
        event: PlayerEvent | LinkClickedEvent | CardEvents | CollectionEvent,
    ) => void
    adUnitPath: string
    getVideoQueue: GetVideoQueue | undefined
    showInlineVideoTitles: boolean | undefined
    publicationPathname: string | undefined
    log: Logger
}) {
    return (
        <React.Fragment>
            {blocks.map((block, index) =>
                block.kind === 'text' ? (
                    <StyledTextListItem
                        key={index}
                        text={block.text}
                        intentions={block.intentions}
                        tag="li"
                        onEvent={onEvent}
                    />
                ) : (
                    <StyledListItem key={index}>
                        <ArticleBlock
                            key={index}
                            block={block}
                            adUnitPath={adUnitPath}
                            getVideoQueue={getVideoQueue}
                            log={log}
                            onEvent={onEvent}
                            publicationPathname={publicationPathname}
                            showInlineVideoTitles={showInlineVideoTitles}
                        />
                    </StyledListItem>
                ),
            )}
        </React.Fragment>
    )
}
